function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.642 8.51746L14.8121 8.87971L15.2077 8.94013L21.1157 9.84259L16.8182 14.2475L16.5539 14.5184L16.6149 14.892L17.6292 21.1102L12.363 18.199L12.0001 17.9984L11.6373 18.1989L6.37096 21.1094L7.38533 14.8911L7.44627 14.5176L7.18195 14.2466L2.88521 9.84248L8.79252 8.94013L9.18817 8.8797L9.35821 8.51738L11.9997 2.88925L14.642 8.51746ZM6.32943 21.364L6.3295 21.3636L6.32943 21.364Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgStar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Star.a18714c9.svg";
export { ForwardRef as ReactComponent };